import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import ReactLoading from 'react-loading';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

import recordReportOrder from "../functions/recordReportOrder";
import getOrderReportPrice from "../functions/getReportPrice";


import Tools from './ReportToolsPaper';
import ProductCard from './ReportProductCard';

import {ReactComponent as DownloadIcon} from '../assets/icons/download.svg';
import GetAppIcon from '@material-ui/icons/GetApp';


export default function ExportPanel(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiOutlinedInput-root':{
        height:30
      },
      width:320,
      '& .MuiAccordion-root.Mui-expanded':{
        margin: 0
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 30,
        borderBottom: '0px solid #3D3E4F',
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 10
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: '#63D764',
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& .MuiRadio-root': {
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 9,
      },
      '& .MuiRadio-colorSecondary.Mui-checked': {
        color: '#f50057',
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 9,
      },
      '& a': {
        color: '#0C4C35',
      }
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    sizecontainer:{
      marginLeft: 5,
    },
    container: {
      width: 300,
    },
    textField: {
      minWidth: 200,
      paddingRight:5,
      marginBottom:10,
    },
    exportLabel:{
      paddingBottom:10,
    },
    exportAreaLabel:{
      paddingTop:2,
      paddingBottom:2,
    },
    textItemFont:{
      fontSize:12
    },
    priceLabel: {
      paddingBottom:5,
    },
    textgridField:{
      paddingTop:2,
    },
    priceTable:{
      paddingTop:10,
      paddingBottom:10,
    },
    purchaseButton:{
      width:160,
      height: 20,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    downloadButton:{
      width: 160,
      height: 40,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    layersSelection:{
      width: 300,
    },
    productList:{
      width: 300,
      minHeight: '50vh',
      maxHeight: '100vh',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    errorTxt:{
      color: '#cc0000',
      paddingBottom:5,
    },
    radioLabel:{
      fontSize:14,
    },
    confirmAreaButton:{
      width:260,
      height: 22,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    backButton: {
      textDecoration: 'underline',
    },
    downloadIcon: {
      height:16,
      width:16
    },

  }));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);
  const [vatRate, setVatRate] = useState(parseFloat(process.env.REACT_APP_VAT_RATE));
  const [reportArea, setReportArea] = useState('');
  const [hasCustomTools, setHasCustomTools] = useState(false);

  const [price, setPrice] = useState(0);
  const [vat, setVAT] = useState(0);
  const [total, setTotal] = useState(0);


  const [layersdisabled, setLayersdisabled] = useState(true);
  const [confirmAreadisabled, setConfirmAreadisabled] = useState(true);
  const [downloaddisabled, setDownloaddisabled] = useState(true);

  const [hasData, setHasData] = useState(true);
  const [hasLayer, setHasLayer] = useState(false);
  const [hasDownload, setHasDownload] = useState(false);

  const [orderID, setOrderID] = useState(0);
  const [isProcess, setIsProcess] = useState(true);
  const [orderStatus, setOrderStatus] = useState('');
  const [doPoll, setDoPoll] = useState(false);
  const [pollTimer, setPollTimer] = useState(null);

  //Export data product list.
  const [dataProducts, setDataProducts] = useState([]);
  const [storedProducts, setStoredProducts] = useState([]);
  const [exportArea, setExportArea] = useState([]);

  //Enables / disableds the purchase button.
  const [purchaseDisabled, setPurchaseDisabled] = useState(true);

  const [projectReference, setProjectReference] = useState(sState.projectreference);
  const [hasPRError, setHasPRError] = useState(false);
  const [poNumber, setPoNumber] = useState(sState.userreference);

  /**
   * Loads the data export layer list options.
   * If not first time, compares current list  
   */
  useEffect(() => {

    const currentList = sState.reportListPrice;
    if (storedProducts.length > 0){
      storedProducts.forEach(function (d) {
        if (d.selected === true){
          currentList.forEach(function (c) {
            if (parseInt(d.productid) === parseInt(c.productid)){
              c.selected = true;
            }
          });
        }
      });
      setStoredProducts([]);
    }
   setDataProducts(currentList);
  },[sState.reportListPrice]);


  /**
   * On change of the required data area post change.
   * Starting point for data orders.
   */
  useEffect(() => {
        const d = {
          fixedsize: reportArea,
        }
        sDispatch({
          type: "setreport",
          payload: { report: d}
        });

  },[reportArea]);


  const handleDataAreaChange = (event) => {
    setReportArea(event.target.value);

    if (event.target.value === 'custom'){
      setHasCustomTools(true);
    } else {
      setHasCustomTools(false);
    }
  };

  useEffect(() => {
    sDispatch({ type: "setreference", payload: { projectreference: projectReference, userreference:poNumber} });
  },[projectReference, poNumber]);


  /**
   * Listens from mapobjects to see if a data export area has been drawn. 
   */
  useEffect(() => {
    if (sState.reportgeom.area > 0){
      setConfirmAreadisabled(false);
    } else {
      setConfirmAreadisabled(true);
      setHasLayer(false);
      setLayersdisabled(true);
    };
    let a = parseFloat(sState.reportgeom.area) * 0.0001;
    if (reportArea === '1ha') { a = 1; }
    if (reportArea === '4ha') { a = 4; }
    if (reportArea === '10ha') { a = 10; }
    if (reportArea === '15ha') { a = 15; }

    setExportArea("Area selected:  "+a.toFixed(2).toString()+"ha");

    if (hasLayer){ //If prices are shown update.
      const displayedList = JSON.parse(JSON.stringify(dataProducts))
      setStoredProducts(displayedList);

      getReportPrices();
    }
  },[sState.reportgeom]);

  /**
   * Updates pricing if layer list changes.
   */
  useEffect(() => {
    if (hasLayer){ //If prices are shown update.
      calculateOrderPrice(dataProducts);
    }
  },[dataProducts]);

  /**
   * Calculates the total order price
   */
  const calculateOrderPrice = (list) => {
    let oPrice = 0;
    let bSelected = true; 
    list.forEach(function (d) {
      if (d.selected === true){
        oPrice += parseFloat(d.price);
        bSelected = false;
      }
    });
    setPurchaseDisabled(bSelected);
    const dprice = parseFloat(oPrice).toFixed(2);
    const vprice = parseFloat(parseFloat(dprice/100) * parseFloat(vatRate)).toFixed(2);
    const tprice = parseFloat(parseFloat(dprice) + parseFloat(vprice)).toFixed(2);

    setPrice(dprice);
    setVAT(vprice);
    setTotal(tprice);
  }


  /**
   * Handles the order of the print.
   */
  const handlePurchase = () => {

    let hasError = false;
    if (projectReference.length <= 1 ){
      setHasPRError(true);
      hasError = true;
    } else {
      setHasPRError(false);
    }

    if (!hasError){

      setHasData(false);
      setHasLayer(false);
      setHasDownload(true);
      setDownloaddisabled(false);
      setPurchaseDisabled(true);

      const dataPrice = {};
      dataPrice.price = price;
      dataPrice.vat = vat;
      dataPrice.total = total;
      //Stores the order transaction.       
      
      let date = new Date();
      date.setMonth(date.getMonth() + 12);
      const day= ('0'+date.getDate()).slice(-2);
      const month = ('0'+(date.getMonth()+ 1)).slice(-2);
      const expiryDate = date.getFullYear()+'-'+ month +'-'+day;

      const prodOrder = [];
      dataProducts.forEach(function (d) {
        if (d.selected === true){
          prodOrder.push(d);
        }
      });

      recordReportOrder(sState, dataPrice, prodOrder, '12 months', expiryDate, sDispatch, "ordered", uState.company.type);

      //Clear screen
      sDispatch({ type: "setUserAction", payload: { action: "clearReport" } });
    }
  };


  /**
   * If the selection of item has changed.
   */
  const handleProductSelect = (productid, selected, format) => {

    const layerlist = JSON.parse(JSON.stringify(dataProducts));
  
    for (let d = 0; d < layerlist.length; d++) {
      if (parseInt(layerlist[d].productid) === parseInt(productid)){
        if (selected) { layerlist[d].selected = true;  } else { layerlist[d].selected = false; } 
        layerlist[d].selectedFormat = format;
        break;
      }
    }
    setDataProducts(layerlist);
    calculateOrderPrice(layerlist);
  }

  /**
   * Confirms the selected area.
   */
  const handleConfirmExportArea =()=>{

    getReportPrices();
    setHasData(false);
    setHasLayer(true);
    setLayersdisabled(false);
  }

  const getReportPrices =()=>{
    const param = {
      fixedsize: reportArea,
    }

    getOrderReportPrice(sState,  param, sDispatch,  uState.company.pricingid, uState.company.type);
  }

  /**
   * Goes back to define export area.
   */
  const handleDefineExportArea =()=>{
    setHasData(true);
    setHasLayer(false);
    setLayersdisabled(true);
  }


  return (
    <div className={classes.root}>
      <Accordion expanded={hasData} onChange={e => setHasData(!hasData)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Define your area of interest</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box component="div" className={classes.container}>  
          <FormControl component="fieldset" className={classes.container}>
            <Box className={classes.exportLabel} fontWeight="fontWeightBold" fontSize={14}>Select Report size</Box>
            <RadioGroup aria-label="dataarea" name="dataarea" className={classes.sizecontainer} value={reportArea} onChange={handleDataAreaChange}>
              <FormControlLabel value="1ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 1ha (100m x 100m)" />
              <FormControlLabel value="4ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 4ha (200m x 200m)" />
              <FormControlLabel value="10ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 10ha (316m x 316m)" />
              <FormControlLabel value="15ha" classes={{ label: classes.radioLabel }} control={<Radio />} label="Fixed 15ha (387m x 387m)" />
              <FormControlLabel value="custom" disabled={true} classes={{ label: classes.radioLabel }} control={<Radio />} label="Custom" />
            </RadioGroup>
          </FormControl>
          {hasCustomTools ? (<Tools geometry={sState.reportgeom}/>) : ( '' )}
          <Box className={classes.exportAreaLabel} fontSize={12}>{exportArea}</Box>
          <Button className={classes.confirmAreaButton} onClick={handleConfirmExportArea} disabled={confirmAreadisabled}>
            <Box p={1} fontWeight="fontWeightBold" fontSize={12} >Confirm report area</Box>
          </Button>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion disabled={layersdisabled} expanded={hasLayer} onChange={e => setHasLayer(!hasLayer)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Reports available</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Box className={classes.layersSelection}>
          <Box display="flex" flexDirection="row">
            <Box className={classes.exportAreaLabel} fontSize={12} flexGrow={1}>{exportArea}</Box>
            <Button className={classes.backButton} onClick={handleDefineExportArea}><Box fontSize={12} >Back</Box></Button>
          </Box>
          <Box className={classes.productList}>
            {dataProducts.map((item, i) =>
                <ProductCard key={i} productid={item.productid} product={item.productname} formats={item.formats} defaultFormat={item.defaultFormat} price={item.price} tooltip={item.tooltip} selected={item.selected} handleSelect={handleProductSelect} />
            )}
          </Box>

            <Divider />
            <Grid container className={classes.priceTable}>
                <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>Price:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{price}</Box></Grid>
                <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>VAT:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{vat}</Box></Grid>
                <Grid item xs={8}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>Total:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} fontWeight="fontWeightBold" alignItems="right" fontSize={12}>{total}</Box></Grid>
            </Grid>
            <Divider />
            <Grid container className={classes.priceTable}>
              <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>Project Reference</Box></Grid>
              <Grid item xs={9}><TextField id="project_reference" value={projectReference} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.projectRefText} onChange={e => setProjectReference(e.target.value)} required></TextField></Grid>
              <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>PO Number</Box></Grid>
              <Grid item xs={9}><TextField id="ponumber" value={poNumber} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.poText} onChange={e => setPoNumber(e.target.value)}></TextField></Grid>
              { hasPRError ? (<Grid item xs={12}><Box className={classes.errorTxt} fontSize={11}>Project Reference is required</Box></Grid>) : ( '' )}
            </Grid>
            <Divider />
            <Box className={classes.priceLabel} fontSize={12}>By clicking 'Purchase' you are agreeing to our <a href='https://www.mapdata.uk/terms' target='_blank' rel='noopener noreferrer' aria-label="Mapdata.uk terms and conditions">Terms and conditions</a></Box>
            <Button className={classes.purchaseButton} disabled={purchaseDisabled} onClick={handlePurchase}>
              <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Purchase</Box>
            </Button>
        </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion disabled={downloaddisabled} expanded={hasDownload} onChange={e => setHasDownload(!hasDownload)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Your report</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Box className={classes.priceLabel} fontSize={12}>Your report has been ordered and available to download from the my orders section when ready.</Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}